import { Component, OnInit } from '@angular/core';
import { FrameworkContractOut } from 'src/app/services/rest-api/rest-api';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'libero-liquidation-disclaimer',
  templateUrl: './liquidation-disclaimer.component.html',
  styleUrls: ['./liquidation-disclaimer.component.scss'],
  standalone: false
})
export class LiquidationDisclaimerComponent implements OnInit {
  public contractsInLiquidation: FrameworkContractOut[] = [];

  public constructor(
    public userService: UserService,
  ) { }

  public ngOnInit(): void {
    this.contractsInLiquidation.length = 0;
    this.contractsInLiquidation.push(...this.userService.loggedUser?.validContracts.filter(contract => contract.inLiquidation) ?? []);
  }
}
